import { GetFulfillmentOrdersState } from './getFulfillmentOrders.types'

export const getFulfillmentOrdersInitialState: GetFulfillmentOrdersState = {
  loading: false,
  error: null,
  success: null
}
